import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsconditionComponent } from './termscondition.component';
import { TermsConditionRoutingModule } from './termscondition-routing.module';


@NgModule({
  declarations: [
    TermsconditionComponent
  ],
  imports: [
    TermsConditionRoutingModule,
    CommonModule
  ]
})
export class TermsconditionModule { }
